export function isNode() {
  return !!window.__getComponentInNode;
}

export function other() {}
